import { FC, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import * as ReactDOM from "react-dom";
import { Editor, PointRef } from "slate";
import { ReactEditor, useSlate } from "slate-react";

import { IAgent } from "store/entities/agents";

import { MentionsList } from "./MentionsList";

interface IProps {
  point: PointRef | null;
  onSelect(agent: IAgent): void;
}

export const Mentions: FC<IProps> = ({ point, onSelect }) => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  const [portalCreated, setPortalCreated] = useState(false);

  const editor = useSlate();

  const createPortal = useCallback(() => {
    const newPortal = document.createElement("div");

    newPortal.className = "mentions-ui-portal";
    document.body.appendChild(newPortal);
    setPortalCreated(true);
  }, []);

  const destroyPortal = useCallback(() => {
    const toRemovePortal = document.querySelector(".mentions-ui-portal");

    if (toRemovePortal) {
      document.body.removeChild(toRemovePortal);
    }
  }, []);

  const positionUI = (): void => {
    const target = point?.current;
    const tooltip = tooltipRef.current;

    if (target && tooltip) {
      const targetRange = Editor.range(editor, target, Editor.after(editor, target, { unit: "character" }));
      const domRange = ReactEditor.toDOMRange(editor, targetRange);
      const rangeBox = domRange.getBoundingClientRect();

      tooltip.style.top = `${rangeBox.top + window.scrollY - tooltip.offsetHeight}px`;
      tooltip.style.left = `${rangeBox.left + window.scrollX}px`;
    }
  };

  useEffect(() => {
    createPortal();

    return destroyPortal;
  }, [createPortal, destroyPortal]);

  useLayoutEffect(() => {
    positionUI();
  });

  const mentionsPortal = document.querySelector(".mentions-ui-portal");

  return portalCreated && mentionsPortal && editor.mentions.isActive()
    ? ReactDOM.createPortal(
        <div ref={tooltipRef} style={{ position: "absolute" }}>
          <MentionsList onSelect={onSelect} />
        </div>,
        mentionsPortal
      )
    : null;
};
